export default {
  getWizardValue: (state) => (key) => state.event[key],
  wizardValues: (state) => state.event
}
